import { BaseService } from "@/script/core/service/BaseService";
import { Success } from "@/script/core/service/DataService";

export class ProductCategoryService extends BaseService {
  loadProductCategorys(success: Success) {
    const productCategoryService = new ProductCategoryService();
    productCategoryService.loadAllList(
      "/api/shop/product_category/list",
      function (data: any) {
        success(data.list);
      },
      function (error: Error) {
        console.error("读取商品分类数据失败，失败原因：" + error.message);
      }
    );
  }
}
